import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';

interface ILabelRadioProps {
    enabled?: boolean;
}

export const ButtonRadioContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 0px 10px;
    cursor: pointer;
`

export const ButtonRadio = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    background-color: ${(props: ILabelRadioProps) => (props.enabled || props.enabled === undefined) ? "#bdbdbd" : "rgba(189, 189, 189, 0.5)" };
    border-radius: 50%;
`

export const ButtonRadioWhite = styled.span`
    position: absolute;
    top: 1px;
    left: 1px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: white;
    display: block;
`

export const ButtonRadioInside = styled.span`
    position: absolute;
    top: 6px;
    left: 6px;
    height: 12px;
    width: 12px;
    background-color: #ff7319;
    border-radius: 50%;
    display: none;
`

export const InputRadio = styled.input`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    &:checked ~ ${ButtonRadio}{
        background-color: #ff7319;
    }
    &:checked ~ ${ButtonRadioInside}{
        display: block;
    }
`

export const RadioOptions = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
`

export const RadioOption = styled.div`
    display: flex;
    position: relative;
    align-items: center;
`

export const LabelRadio = styled.label`
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #000;
    margin: 0px 0px 0px 12px;
    color: ${(props: ILabelRadioProps) => (props.enabled || props.enabled === undefined) ? "#000000" : "rgba(112, 112, 112, 0.5)" };
`

export const LabelMessage = styled.label`
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: ${(props: ILabelRadioProps) => (props.enabled || props.enabled === undefined) ? "#000000" : "rgba(112, 112, 112, 0.5)" };
    margin: 0px 0px 0px 5px;
`
